// src/pages/treatments/CosmeticDentistry.jsx
import { Link } from 'react-router-dom';
import CosmeticDentistryT9 from '../../Assets/images/CosmeticDentistryT9.png'
import CD from '../../Assets/images/Cosmetic Dentistry.jpg'
const CosmeticDentistry = () => {
  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={CosmeticDentistryT9}
            alt="Cosmetic Dentistry"
            className="w-full h-full object-cover brightness-75"
          />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Cosmetic Dentistry
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Enhance your smile's appearance
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Cosmetic Dentistry</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={CD}
                alt="Cosmetic Dentistry Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Cosmetic Dentist
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                This dental procedure helps you improve the appearance of the teeth and gums. The process concentrates on lightening the color of your enamel and gums. The shade of the teeth may lighten three-to-four times and need periodical bleaching depending on the lifestyle.
              </p>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CosmeticDentistry;